import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faAnalytics } from '@fortawesome/pro-regular-svg-icons/faAnalytics';
import { faPhoneLaptop } from '@fortawesome/pro-regular-svg-icons/faPhoneLaptop';
import { faSuitcase } from '@fortawesome/pro-regular-svg-icons/faSuitcase';
import { faFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faBadgeDollar } from '@fortawesome/pro-regular-svg-icons/faBadgeDollar';
// import { faChartLine } from '@fortawesome/pro-regular-svg-icons/faChartLine';
import { faCertificate, faCheckCircle, faCog, faMoneyCheckAlt, faSignInAlt, faTags, faThLarge, faTimesCircle, faUserCircle, } from '@fortawesome/pro-regular-svg-icons';
import { AvailableIcons } from '../../components/Icon/Icon.element';
var ICON_COLOR = '#ffffff';
var ICON_WIDTH = 16;
var ICON_HEIGHT = 16;
export var SideBarNavigation = function (orgId) { return ({
    mainMenu: [
        {
            id: 'Apps',
            label: 'Apps',
            iconName: AvailableIcons.Grid,
            slug: '/apps',
            activationPathMatch: '/apps(/*)?',
        },
        {
            id: 'Analytics',
            label: 'Analytics',
            iconName: AvailableIcons.Chart,
            slug: '/analytics',
            activationPathMatch: '/analytics(/*)?',
            target: "org:".concat(orgId, ":analytics"),
        },
        {
            id: 'Organization',
            label: 'Organizations',
            iconName: AvailableIcons.Organizations,
            slug: "/organizations?",
            activationPathMatch: '/organizations(/*)?',
        },
        {
            id: 'Partner',
            label: 'Partner',
            iconName: AvailableIcons.Partners,
            slug: '/partner/users',
            activationPathMatch: '/partner(/*)?',
            target: "partner:123:users",
        },
        {
            id: 'System',
            label: 'System',
            iconName: AvailableIcons.SystemSettings,
            slug: '/system',
            activationPathMatch: '/system(/*)?',
            target: "system:123",
        },
    ],
    secondaryMenus: {
        partnerMenu: [
            {
                header: 'Analytics',
                slug: "/partner/analytics",
                activationPathMatch: '/partner/analytics/*',
                icon: (_jsx(FontAwesomeIcon, { icon: faAnalytics, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
            },
            {
                header: 'Users',
                slug: "/partner/users",
                activationPathMatch: '/partner/users',
                icon: (_jsx(FontAwesomeIcon, { icon: faUsers, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
            },
            {
                header: 'Organizations',
                slug: "/partner/organizations",
                activationPathMatch: "//partner/organizations/(active|pending).*/",
                icon: (_jsx(FontAwesomeIcon, { icon: faSuitcase, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
                children: [
                    {
                        label: 'Active Organizations',
                        slug: "/partner/organizations/active",
                        activationPathMatch: '/partner/organizations/active',
                        icon: (_jsx(FontAwesomeIcon, { icon: faCheckCircle, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
                    },
                    {
                        label: 'Pending Organizations',
                        slug: "/partner/organizations/pending",
                        activationPathMatch: '/partner/organizations/pending',
                        icon: (_jsx(FontAwesomeIcon, { icon: faTimesCircle, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
                    },
                ],
            },
            {
                header: 'Resellers',
                slug: "/partner/resellers",
                activationPathMatch: '/partner/resellers/*',
                icon: (_jsx(FontAwesomeIcon, { icon: faBadgeDollar, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
            },
            {
                header: 'Bundles',
                slug: "/partner/bundles",
                activationPathMatch: '/partner/bundles/*',
                icon: (_jsx(FontAwesomeIcon, { icon: faFileCertificate, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
            },
            {
                header: 'Discounts',
                slug: "/partner/discount",
                activationPathMatch: '/partner/discount/*',
                icon: (_jsx(FontAwesomeIcon, { icon: faTags, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
            },
            {
                header: 'Developer Plans',
                slug: "/partner/dev-plan",
                activationPathMatch: '/partner/dev-plan/*',
                icon: (_jsx(FontAwesomeIcon, { icon: faCertificate, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
            },
            {
                header: 'Sign up Flows',
                slug: "/partner/signflow",
                activationPathMatch: '/partner/signflow/*',
                icon: (_jsx(FontAwesomeIcon, { icon: faSignInAlt, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
            },
        ],
        systemMenu: [
            {
                header: 'Platform',
                slug: '/system',
                activationPathMatch: '/system/*',
                icon: (_jsx(FontAwesomeIcon, { icon: faPhoneLaptop, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
            },
        ],
        organizationMenu: [
            // {
            //   header: 'Dashboard',
            //   label: 'Dashboard',
            //   slug: `/organizations/${orgId}/dashboard?`,
            //   activationPathMatch: '/organizations/:organizationId/dashboard',
            //   icon: (
            //     <FontAwesomeIcon
            //       icon={faChartLine}
            //       style={{ width: ICON_WIDTH, height: ICON_HEIGHT }}
            //       color={ICON_COLOR}
            //       fixedWidth
            //     />
            //   ),
            //   target: [`org:${orgId}:orgadmin`],
            // },
            {
                header: 'Apps',
                label: 'Apps',
                slug: "/organizations/".concat(orgId, "/apps?"),
                activationPathMatch: '/organizations/:organizationId/apps/*',
                icon: (_jsx(FontAwesomeIcon, { icon: faThLarge, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
                target: ["org:".concat(orgId, ":apps"), "org:".concat(orgId, ":orgadmin")],
            },
            {
                header: 'Members',
                label: 'Members',
                icon: (_jsx(FontAwesomeIcon, { icon: faUsers, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
                slug: "/organizations/".concat(orgId, "/members?"),
                activationPathMatch: '/organizations/:organizationId/members/*',
                target: ["org:".concat(orgId, ":orgadmin")],
            },
            {
                header: 'Roles',
                label: 'Roles',
                icon: (_jsx(FontAwesomeIcon, { icon: faUserCircle, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
                slug: "/organizations/".concat(orgId, "/roles?"),
                activationPathMatch: '/organizations/:organizationId/roles/*',
                target: ["org:".concat(orgId, ":orgadmin")],
            },
            // {
            //   header: 'Publishing Licenses',
            //   label: 'Publishing Licenses',
            //   icon: (
            //     <FontAwesomeIcon
            //       icon={faFileCertificate}
            //       style={{ width: ICON_WIDTH, height: ICON_HEIGHT }}
            //       color={ICON_COLOR}
            //       fixedWidth
            //     />
            //   ),
            //   slug: `/organizations/${orgId}/publicationBundles?`,
            //   activationPathMatch: '/organizations/:orgId/publicationBundles(/*)?',
            //   target: [`org:${orgId}:orgadmin`],
            // },
            {
                header: 'Developer Plans',
                label: 'Developer Plans',
                icon: (_jsx(FontAwesomeIcon, { icon: faCertificate, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
                slug: "/organizations/".concat(orgId, "/developerPlans"),
                activationPathMatch: '/organizations/:orgId/developerPlans/*',
                target: ["org:".concat(orgId, ":orgadmin")],
            },
            {
                header: 'Billing',
                label: 'Billing',
                icon: (_jsx(FontAwesomeIcon, { icon: faMoneyCheckAlt, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
                slug: "/organizations/".concat(orgId, "/payments"),
                activationPathMatch: '/organizations/:orgId/payments/*',
                target: ["org:".concat(orgId, ":orgadmin")],
            },
            {
                header: 'Settings',
                label: 'Settings',
                icon: (_jsx(FontAwesomeIcon, { icon: faCog, style: { width: ICON_WIDTH, height: ICON_HEIGHT }, color: ICON_COLOR, fixedWidth: true })),
                slug: "/organizations/".concat(orgId, "/edit"),
                activationPathMatch: '/organizations/:orgId/edit',
                target: ["org:".concat(orgId, ":orgadmin")],
            },
        ],
    },
    profileMenu: [
        {
            label: 'User Profile',
            slug: '/preference',
            iconName: AvailableIcons.Preferences,
        },
        {
            label: 'Data & Privacy',
            slug: '/dataprivacy',
            iconName: AvailableIcons.DataAndPrivacy,
        },
        {
            label: 'Sign out of Appspotr',
            slug: 'LOGOUT',
            iconName: AvailableIcons.SignOut,
        },
    ],
}); };
